import { render } from "./product_card.vue?vue&type=template&id=6c057836&scoped=true"
import script from "./product_card.vue?vue&type=script&lang=js"
export * from "./product_card.vue?vue&type=script&lang=js"

import "./product_card.vue?vue&type=style&index=0&id=6c057836&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c057836"]])

export default __exports__